
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 448 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m136.97 131.515 7.071 7.07c4.686 4.686 4.686 12.284 0 16.971l-83.928 83.444h375.887c6.627 0 12 5.373 12 12v10c0 6.627-5.373 12-12 12h-375.887l83.928 83.444c4.686 4.686 4.686 12.284 0 16.971l-7.071 7.07c-4.686 4.686-12.284 4.686-16.97 0l-116.48499-116c-4.686-4.686-4.686-12.284 0-16.971l116.48499-115.999c4.686-4.687 12.284-4.687 16.97 0z","fill":"#000"}})])
          )
        }
      }
    